import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    mustBeInProject: string;
    mustSelectLocation: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Validation error when no Frame.io folder / project is selected for upload */
            mustBeInProject: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useExportSettingsValidation.mustBeInProject?c=36ug08qr8438e", defaultMessage: "Must select a Frame.io folder or be in a Frame.io project to export" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Validation error when "save a local copy" is on but no local folder is chosen */
            mustSelectLocation: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useExportSettingsValidation.mustSelectLocation?c=3dpvadqtoo22w", defaultMessage: "Must select a location on your computer to save a copy" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
